import React from 'react';
import {
   AlertDialog,
   AlertDialogAction,
   AlertDialogCancel,
   AlertDialogContent,
   AlertDialogDescription,
   AlertDialogFooter,
   AlertDialogHeader,
   AlertDialogTitle,
} from "@/components/ui/alert-dialog";

const ConfirmationDialog = ({
   isOpen,
   onClose,
   onConfirm,
   title,
   description,
   confirmText = "Confirm",
   cancelText = "Cancel",
   variant = "destructive" // or "default"
}) => {
   return (
      <AlertDialog open={isOpen} onOpenChange={onClose}>
         <AlertDialogContent>
            <AlertDialogHeader>
               <AlertDialogTitle>{title}</AlertDialogTitle>
               <AlertDialogDescription>{description}</AlertDialogDescription>
            </AlertDialogHeader>
            <AlertDialogFooter>
               <AlertDialogCancel>{cancelText}</AlertDialogCancel>
               <AlertDialogAction
                  onClick={onConfirm}
                  className={variant === "destructive" ? "bg-destructive text-destructive-foreground hover:bg-destructive/90" : ""}
               >
                  {confirmText}
               </AlertDialogAction>
            </AlertDialogFooter>
         </AlertDialogContent>
      </AlertDialog>
   );
};

export default ConfirmationDialog;
